import { render, staticRenderFns } from "./FaceRetrieve.vue?vue&type=template&id=67805c50&scoped=true"
import script from "./FaceRetrieve.vue?vue&type=script&lang=js"
export * from "./FaceRetrieve.vue?vue&type=script&lang=js"
import style0 from "./FaceRetrieve.vue?vue&type=style&index=0&id=67805c50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67805c50",
  null
  
)

export default component.exports